import React from 'react';
import { Box } from '@tonic-ui/react';
import { useThemeColorStyle } from '../hooks/use-theme-color-style';

const CenteredLayout = (props) => {
  const colorStyle = useThemeColorStyle();
  return (
    <Box
      backgroundColor={colorStyle.background.primary}
      width={493}
      padding="10x"
      marginX="auto"
      marginY="40x"
      borderWidth="1px"
      borderStyle="solid"
      borderColor={colorStyle.centeredLayout.borderColor}
      {...props}
    />
  );
};

CenteredLayout.displayName = 'CenteredLayout';
export default CenteredLayout;
